export const SORTING_BUTTON_ICON_HEIGHT = 16 // px

export const QA_NAME_SORTING_BUTTON = 'sorting'
